export default __webpack_public_path__ + "static/media/Timeline.0606f6b2.jpg";